import View from './View.js';
import * as model from "./../model.js"
class ResultsView extends View {
    _parentElement = document.querySelector('.results');
    _errorMessage = 'No recipes found for your query! Please try again ;)';
    _message = '';

    /**
     * 
     * @returns {string} string markup for show results of search
     */
    _generateMarkup() {
        return this._data?.map(el => this._generateMarkupPreview(el)).join("")

    }

    /**
     * 
     * @param {string} text to find the searched text in search result items
     * @returns {string} that separate searched text and title  
     */
    _generateSearchRow(text) {
        const value = model.state.search.query;
        let regex = new RegExp(value, "gi");
        let titleToDisplay = text.replace(regex, '<span class="searchedTerm">$&</span>');
        return titleToDisplay
    }

    /**
     * 
     * @param {Function} handler to handle add Item to history (localStorage) 
     */
    addItemToList(handler) {
        this._parentElement.addEventListener("click", function (e) {
            const current = e.target.closest(".preview");
            if (!current) return
            handler(current.getAttribute("id"))
        })
    }

    /**
     * 
     * @param {object} data for render each item of search results 
     * @returns {string} a string markup 
     */
    _generateMarkupPreview(data) {


        return `
            <li class="preview" aria-label="${data?.title}" id=${data?.id} >
        <div role="link" class="preview__link">
            <div class="preview__data">
                <h4 class="preview__title">${this._generateSearchRow(data?.title)} </h4>
            </div>
        </div>
            </li>
            `
    }
}

export default new ResultsView();



